import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import {
  Accordion,
  mediaHelper,
  paletteHelper,
  spacingHelper,
  Text,
  typographyHelper,
} from '@property.com.au/ui-kit';
import type { ChildcareCentre } from './types';
import {
  CHILDCARE_FACT_WIDTH,
  CHILDCARE_NAME_WIDTH,
} from './subcomponents/ChildcareAccordionItem/ChildcareAccordionItem.styled';
import { ChildcareAccordionItem } from './subcomponents/ChildcareAccordionItem/ChildcareAccordionItem';

const DesktopChildcareFactHeaderWrapper = styled.div`
  ${mediaHelper('tabletMax')} {
    display: none;
  }
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  /* stylelint-disable declaration-block-no-redundant-longhand-properties */
  /* border + name size + margin + margin */
  margin-left: calc(
    1px + ${CHILDCARE_NAME_WIDTH}px + ${spacingHelper('medium')} + ${spacingHelper('medium')}
  );
  /* border + margin + accordion + margin */
  margin-right: calc(
    1px + ${spacingHelper('medium')} + ${spacingHelper('medium')} + ${spacingHelper('medium')}
  );
  margin-top: ${spacingHelper('medium')};
  margin-bottom: ${spacingHelper('extraSmall')};
  /* stylelint-enable declaration-block-no-redundant-longhand-properties */
`;

const ChildcareFactHeader = styled(Text)<{ $index: number }>`
  ${typographyHelper('overline')};
  color: ${paletteHelper('textSecondary')};
  width: ${(props) => CHILDCARE_FACT_WIDTH[props.$index]}px;
`;

interface ChildcareAccordionTableProps {
  childcareCentres?: ChildcareCentre[] | null;
  childcareFactHeader: string[];
}

export const ChildcareAccordionTable: FunctionComponent<ChildcareAccordionTableProps> = ({
  childcareFactHeader,
  childcareCentres,
}) => {
  return (
    <>
      <DesktopChildcareFactHeaderWrapper>
        {childcareFactHeader.map((header, index) => (
          <ChildcareFactHeader key={header} $index={index}>
            {header}
          </ChildcareFactHeader>
        ))}
      </DesktopChildcareFactHeaderWrapper>

      <Accordion>
        {childcareCentres?.map(
          ({
            name,
            vacancyBadge,
            openingHours,
            address,
            isDefaultOpen,
            childcareFacts,
            webLinks,
            tracking,
          }) => {
            return (
              <ChildcareAccordionItem
                key={name}
                name={name}
                vacancyBadge={vacancyBadge}
                openingHours={openingHours}
                address={address}
                isDefaultOpen={isDefaultOpen}
                childcareFacts={childcareFacts}
                webLinks={webLinks}
                tracking={tracking}
              />
            );
          },
        )}
      </Accordion>
    </>
  );
};
